import {
  ExerciseTagDto,
  ICreateExerciseTagCommand,
  PaginatedListOfExerciseTagDto,
} from "@growth-machine-llc/stridist-api-client";
import { useOptimisticUpdateMutation } from "../../../../hooks/useOptimisticUpdateMutation";
import { COACH_EXERCISE_TAGS_LIST_QUERY_KEY } from "../../../../routes/coach/library/exercise-library/list/CoachExerciseTagsListRoute";
import ExerciseTagsService from "../../../../services/ExerciseTagsService";
import { useCurrentUserId } from "../../../../hooks/useCurrentUser";
import { QueryClient, useQueryClient } from "@tanstack/react-query";
import {
  ALL_EXERCISE_TAGS_QUERY_KEY,
  COACH_EXERCISE_LIBRARY_ASSETS_QUERY_KEY,
} from "../../ExercisesTableScreen";
import {
  IQueryToInvalidate,
  tagOnSuccessHandler,
} from "../../../coach-clients-tags/mutations/useCreateClientTag";

export const INVALIDATE_KEYS_ON_EXERCISE_TAGS_LIST_UPDATE: IQueryToInvalidate[] =
  [
    {
      queryKey: [COACH_EXERCISE_LIBRARY_ASSETS_QUERY_KEY],
      refetchType: "none",
    },
    { queryKey: [ALL_EXERCISE_TAGS_QUERY_KEY] },
  ];

export function useCreateExerciseTag() {
  const coachId = useCurrentUserId();
  const queryClient = useQueryClient();

  return useOptimisticUpdateMutation({
    queryKey: [COACH_EXERCISE_TAGS_LIST_QUERY_KEY],
    mutationFn: ExerciseTagsService.createExerciseTag,
    successToastMessage: "Exercise tag created.",
    optimisticUpdater: {
      updateFn: (
        oldData: PaginatedListOfExerciseTagDto,
        variables: ICreateExerciseTagCommand,
        tempId: number,
      ) => {
        const newData = PaginatedListOfExerciseTagDto.fromJS(oldData);
        newData.totalCount = newData.items.unshift(
          ExerciseTagDto.fromJS({
            ...variables,
            id: tempId,
            coachId,
          }),
        );
        return newData;
      },
    },
    exactQueryKey: false,
    successUpdater: {
      updateFn: (oldData, variables, tempId) => {
        oldData.items = oldData.items?.map((asset) => {
          if (asset.id === tempId) {
            asset.id = variables;
          }
          return asset;
        });
        return oldData;
      },
    },
    options: {
      onSuccess: () => {
        tagOnSuccessHandler(
          queryClient,
          INVALIDATE_KEYS_ON_EXERCISE_TAGS_LIST_UPDATE,
        );
      },
    },
  });
}
